import React from 'react'
import ArchivedBrandsPage from '../../Components/ArchivedBrands/ArchivedBrands'

const ArchivedBrands = () => {
  return (
    <div>
        <ArchivedBrandsPage />
    </div>
  )
}

export default ArchivedBrands
